import React, { useState, useEffect } from "react";
import moment from "moment";

import UserStatus from "./UserStatus";
import TimePicker from "./TimePicker";
import { getUsers } from "../../../../services/auth";
import firebase, { FS } from "../../../../services/firebase";
import { useSelector } from "react-redux";
import { ADMIN_ROLE, TIME_FORMAT } from "../../../../constants";
import { latestActivityByUserId } from "../../../../utils/latestActivityByUserId";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [activityByUserId, setActivityByUserId] = useState({});
  const currentUser = useSelector((state) => state.user?.currentUser);

  // One listener for everyone's activity today. A listener per user meant
  // dozens of targets to re-add every time the connection dropped.
  useEffect(() => {
    const date = moment().tz("Australia/Melbourne").format(TIME_FORMAT.DATE_WITH_DASH);
    const unsubscribe = FS.onSnapshot(
      FS.query(FS.collection(firebase.modularFirestore(), "user_activities"), FS.where("date", "==", date)),
      (snapshots) => {
        setActivityByUserId(latestActivityByUserId(snapshots.docs.map((snapshot) => snapshot.data())));
      }
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const users = await getUsers(ADMIN_ROLE);
        setUsers(users.filter((user) => !user.isITStaff).filter((user) => !user.disabled));
      } catch (error) {
        setUsers([]);
      }
    })();
  }, []);

  return (
    <div className="is-flex is-justify-content-space-between mb-2">
      <ul className="columns is-gapless mb-0" style={{ width: "95%", overflowX: "scroll" }}>
        {users.map((user) => (
          <UserStatus key={`${JSON.stringify(user)}`} user={user} activity={activityByUserId[user.uid] ?? null} />
        ))}
      </ul>
      {currentUser?.isSupervisor && <TimePicker />}
    </div>
  );
};
export default UserList;
